/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import type { FC } from "react";

interface ImageSwipeDotsProps {
  total: number;
  current: number;
  className: string;
  setCurrent: (index: number) => void;
}

export const ImageSwipeDots: FC<ImageSwipeDotsProps> = ({
  total,
  current,
  className,
  setCurrent,
}) => {
  return (
    <div className={`flex space-x-2 ${className}`}>
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={Math.random()}
          className={`w-2.5 h-2.5 rounded-full cursor-pointer ${
            index === current ? "bg-primary" : "bg-primary opacity-10"
          }`}
          onClick={() => setCurrent(index)}
        />
      ))}
    </div>
  );
};
